import React from "react"
import styles from "./styles.module.css"
import clsx from "clsx"

const NADA_LIGHT_GIF_URL =
  "https://bandnada.s3.amazonaws.com/static/gifs/nadalight-optimize_v1.gif"

const PremiereHeader = ({ post, size }) => {
  const pixels = size === "large" ? 200 : 130
  return (
    post.is_bn_premiere && (
      <>
        <div className={clsx(styles.premiereHeader, "col-span-12")}>
          nadaLight
        </div>
        <div className="relative col-span-3 col-start-10">
          <div className="absolute right-0">
            <img
              src={NADA_LIGHT_GIF_URL}
              alt="nada light spotlight"
              width={pixels}
              height={pixels}
            />
          </div>
        </div>
      </>
    )
  )
}

export default PremiereHeader
